module.exports = {"nav":{"langChange":"Cheñch yezh","lang":"Yezh","translate":"Treiñ"},"txt":{"close":"Serriñ"}};